"use client";
// TODO: 这里的子组件要用children形式传进来
import React, { useCallback, useState } from "react";
import PhotoSwiper from "./PhotoSwiper";
import { IUploadProps } from ".";
import { FmDrawer as FmUIDrawer } from "@/ui-component";
export interface IWithPhotoSwiperProps<T> {
    mapPhotoSwiperImg?(
        list: any[],
        imgkey?: string,
    ): {
        w: number;
        h: number;
        src: any;
        title: any;
    }[];
    openSetPhotoSwiper?(open: boolean, data: any[], index?: number): void;
    render?: (props: WrapperProps<T>) => React.ReactNode;
}

export type WrapperProps<T> = IUploadProps & T;
function WithPhotoSwiper<T>(WrapComponent: React.FC<WrapperProps<T>>) {
    return (w = 600, h = 450): React.FC<WrapperProps<T>> => {
        w = 1;
        h = 1;
        const WithPhotoSwiperComponent: React.FC<WrapperProps<T>> = (props) => {
            const [photoSwiperOpen, setPhotoSwiperOpen] = useState(false);
            const [photoSwiperData, setPhotoSwiperData] = useState<any[]>([]);
            const [options, setOptions] = useState<Record<string, any>>({});
            // 映射图片数组
            const mapPhotoSwiperImg = (list: any[], imgkey: string) => {
                return list
                    .map((item) => {
                        return {
                            w,
                            h,
                            src: typeof item === "string" ? item : item[imgkey],
                            title: typeof item === "string" ? "" : item.title,
                        };
                    })
                    .filter((item) => item.src);
            };
            // 打开并设置图片数据和打开图片顺序
            const openSetPhotoSwiper = useCallback(
                (open: boolean, data: any[], index = 0) => {
                    setPhotoSwiperOpen(open);
                    setOptions({
                        index,
                    });
                    if (data) {
                        setPhotoSwiperData(data);
                    }
                },
                [],
            );

            return (
                <>
                    <WrapComponent
                        {...props}
                        mapPhotoSwiperImg={mapPhotoSwiperImg}
                        openSetPhotoSwiper={openSetPhotoSwiper}
                    />
                    {photoSwiperOpen && (
                        <PhotoSwiper
                            isOpen={photoSwiperOpen}
                            items={photoSwiperData}
                            options={options}
                            onClose={() => setPhotoSwiperOpen(false)}
                        />
                    )}
                </>
            );
        };
        return WithPhotoSwiperComponent;
    };
}

export default WithPhotoSwiper;

export { PhotoSwiperTitle } from "./PhotoSwiper";
